export default __webpack_public_path__ + "static/media/pendenciamentoAprovado.c4b8c757.png";